import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
import { Rating } from "@mui/material";
import { toUpper } from "lodash";
import { useNavigate } from "react-router-dom";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const dummyTopics = [
  {
    id: 1,
    user: "",
    title: "The picture is not displaying properly",
    feedback: "The Yi Home Mobile app is unable to pair with the camera",
    isAdmin: false,
  },
  {
    id: 2,
    user: "",
    title: "Unable to display video",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 3,
    user: "",
    title: "The images are not playing in my video",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
];

const Demo = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

export default function TicketTeamMembers(props: any) {
  const { teamembersdata } = props;
  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);
  const navigate = useNavigate();

  const handleRedirectUncategorisedTickets = () => {
    // navigate("/tickets");
    const stateObj = {
      pageType: "mainReportPage",
    };
    navigate(`/view-uncategorized-ticket`, { state: stateObj });
  };

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#2858D3" : "#2858D3",
    },
  }));

  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Grid sx={{ border: "1px solid #ccc", borderRadius: "8px" }}>
      <Typography className="repu-heading">
        <Typography sx={{ fontWeight: 700, fontSize: "13px" }}>
          TEAM MEMBERS
          {/* <Avatar
            sx={{
              height: "35px",
              width: "35px",
              marginLeft: "5px",
              fontSize: "10px",
              background: "#2858D3",
              display: "inline-flex",
              border: "1px solid #FFF",
            }}
          >
            85
          </Avatar> */}
        </Typography>
        {/* <Typography
          sx={{
            color: "#2858D3",
            fontWeight: 700,
            fontSize: "13px",
            cursor: "pointer",
          }}
          component="div"
          onClick={() => handleRedirectUncategorisedTickets()}
        >
          VIEW TICKETS
        </Typography> */}
      </Typography>
      <div
        style={{
          height: "310px",
          overflowY: "auto",
        }}
      >
        {teamembersdata &&
          teamembersdata.length > 0 &&
          teamembersdata.map((option: any, index: any) => (
            <>
              <div>
                <Accordion
                  sx={{ boxShadow: "none !important" }}
                  key={index}
                  expanded={expanded === index}
                  onChange={handleChange(index)}
                >
                  <AccordionSummary
                    className="teamMembersAccSummaary"
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      margin: "0px !important",
                      padding: "0px 8px !important",
                    }}
                  >
                    <Grid
                      {...props}
                      container
                      sx={{ padding: "10px" }}
                      key={index}
                    >
                      <Grid item xs={12} sm={1.5} md={1.5} lg={1.5} xl={1.5}>
                        <Typography className="prod-logo-txt">
                          <Avatar
                            className="emailsenderavatar"
                            sx={{
                              width: "30px !important",
                              height: "30px !important",
                              fontSize: "13px !important",
                            }}
                          >
                            {option?.emailId &&
                              option.emailId.charAt(0).toUpperCase()}
                          </Avatar>
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={6.5}
                        md={6.5}
                        lg={6.5}
                        xl={6.5}
                        className="textoverflow-ellipsis"
                        style={{}}
                        title={option.emailId}
                      >
                        {option.emailId}
                        <BorderLinearProgress
                          variant="determinate"
                          // value={45}
                          value={
                            (option.currCount / option.maxCount) * 100 <= 100
                              ? (option.currCount / option.maxCount) * 100
                              : 100
                          } // Calculate the percentage value
                          sx={{ mt: 1 }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={4}
                        md={4}
                        lg={4}
                        xl={4}
                        sx={{
                          justifyContent: "end",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            fontStyle: "italic",
                            fontSize: 12,
                            color: "#676565e0",
                            marginRight: "10px",
                          }}
                        >
                          Tickets
                        </span>{" "}
                        <span style={{ fontSize: 12 }}>
                          {" "}
                          {option.currCount + "/" + option.maxCount}
                        </span>
                        {/* {option.currCount + "/" + option.maxCount} */}
                      </Grid>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      padding: "0 0px 0px 20px !important",
                      background: "#ccc3",
                    }}
                  >
                    {option &&
                      option.ticketCapacity &&
                      option.ticketCapacity.length > 0 &&
                      option.ticketCapacity.map((data: any, i: any) => (
                        <>
                          <Grid
                            {...props}
                            container
                            sx={{ padding: "6px" }}
                            key={index}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={7}
                              md={7}
                              lg={7}
                              xl={7}
                              className="textoverflow-ellipsis-tm"
                              title={
                                data.productName + "-" + data.productVersion
                              }
                            >
                              {/* <span
                                style={{
                                  fontStyle: "italic",
                                  fontSize: 12,
                                  color: "#2858D3",
                                }}
                              >
                                Product:
                              </span>{" "} */}
                              {data.productName} - {data.productVersion}
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              md={4}
                              lg={4}
                              xl={4}
                              sx={{
                                justifyContent: "end",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {/* <span
                                style={{
                                  fontStyle: "italic",
                                  fontSize: 12,
                                  color: "#2858D3",
                                  marginRight: "10px",
                                }}
                              >
                                Tasks
                              </span>{" "} */}
                              <span style={{ fontSize: 12 }}>
                                {" "}
                                {data.currCount + "/" + data.maxCount}
                              </span>
                              {/* {option.currCount + "/" + option.maxCount} */}
                            </Grid>
                          </Grid>
                        </>
                      ))}
                  </AccordionDetails>
                </Accordion>
              </div>
            </>
          ))}
        {teamembersdata && teamembersdata.length == 0 && (
          <Typography
            className="no-data"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {" "}
            No team members found for the selected product
          </Typography>
        )}
      </div>
    </Grid>
  );
}
